module.exports = {"110117001":"滨河街道","110117002":"兴谷街道","110117003":"渔阳地区","110117004":"峪口地区","110117005":"马坊地区","110117006":"金海湖地区","110117101":"东高村镇","110117102":"山东庄镇","110117104":"南独乐河镇","110117105":"大华山镇","110117106":"夏各庄镇","110117108":"马昌营镇","110117110":"王辛庄镇","110117111":"大兴庄镇","110117112":"刘家店镇","110117114":"镇罗营镇","110117213":"黄松峪乡","110117214":"熊儿寨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/110117.json
// module id = 35
// module chunks = 0